/** Desktop app chrome height — keep in sync with `desktop-header.tsx` and sidebar offset in `navbar.tsx`. */
export const DESKTOP_APP_HEADER_HEIGHT = "3.5rem";

export const DESKTOP_APP_HEADER_HEIGHT_CLASS = "h-14";

/** Set by `layout.tsx`; used to align desktop header comms with `PageHeader` actions. */
export const APP_CONTENT_COLUMN_RIGHT_CSS_VAR = "--app-content-column-right";
